// import Cookies from 'js-cookie'
import { Dictionary } from 'vue-router/types/router'
import { setToken } from './cookies'

export enum AuthStatusEnum {
  Auth,
  Invalid,
}

const sessionStorageKey = 'hasAuth'
/**
 * 1. 登录跳转时：至页面时会携带sessionId, 例如：http://localhost:8899/v10/asr?sessionId=OWQ1NTZjO......
 *    将sessionId由前端存至Cookie中
 *
 * 2. 刷新时： 不会携带sessionId 需通过sessionStorage中的hasAuth判断已登录认证过
 *
 * 3. 关闭重新打开时：不会携带sessionId同时sessionStorage中也不会有hasAuth 关闭浏览器即认为退出登录，故清除Cookie
 */
export async function getAuthStatus(query: Dictionary<string | (string | null)[]>): Promise<AuthStatusEnum> {
  const sessionId = query.sessionId as string | undefined

  if (sessionId !== undefined) {
    try {
      setToken(sessionId)
      sessionStorage.setItem(sessionStorageKey, 'true')
      return AuthStatusEnum.Auth
    } catch (error) {
      sessionStorage.removeItem(sessionStorageKey)
      return AuthStatusEnum.Invalid
    }
  } else {
    const hasAuth = sessionStorage.getItem(sessionStorageKey)
    if (hasAuth) {
      return AuthStatusEnum.Auth
    } else {
      return AuthStatusEnum.Invalid
    }
  }
}
